import { ActionTypes } from '../constans/action-types';

const initialState = {
  open: false,
  type: '',
  msg: '',
  isMasterAction: false,
  duration: null,
};

const snackbarReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.OPEN_SNACKBAR:
      return {
        open: true,
        type: payload.type,
        msg: payload.msg,
        isMasterAction: payload.isMasterAction ? payload.isMasterAction : false,
        duration: payload.duration ?? null,
      };
    case ActionTypes.CLOSE_SNACKBAR:
      return { open: false, type: '', msg: '', isMasterAction: false, duration: null };
    default:
      return state;
  }
};

export default snackbarReducer;
